<template>
  <div class="notification-panel">
    <div class="header-notification">
      <div class="header-item">
        <a :href="notificationsLink">
          <svg class="icon-settings">
            <use href="/sprite.svg#settings"></use>
          </svg>
        </a>
        <a v-if="notifications.length" href="#" class="clear-all" @click.prevent="clearAll">
          {{ trans("header.notifications.clear_all") }}
        </a>
        <button v-if="props.isMobileMenuProp" class="close-button" @click="closePanel">
          <svg class="icon-close">
            <use href="/sprite.svg#close"></use>
          </svg>
        </button>
      </div>
    </div>
    <div class="scroll">
      <custom-scrollbar v-if="notifications.length" class="notifications-list custom-scrollbar">
        <div v-for="notification in notifications" :key="notification.id" class="notification-item">
          <div class="message" v-html="notification.content"></div>
          <div class="date">
            <formatted-date class="time" moment-js-format="MMM D" :utc-date="notification.created_at"></formatted-date>
          </div>
        </div>
      </custom-scrollbar>
      <div v-else class="notifications-list empty-notification">
        <div class="label">{{ trans("header.notifications.not_notifications") }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";
  import apiClient from "@/services/api";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import FormattedDate from "@/components/_partials/FormattedDate.vue";

  const emit = defineEmits(["closePanel"]);

  const props = withDefaults(
    defineProps<{
      isMobileMenuProp: boolean;
    }>(),
    {
      isMobileMenuProp: false
    }
  );

  const auctionStore = useAuctionStore();
  const notificationsLink = computed(() => auctionStore.routes["profile.notifications.edit"]);
  const notifications = computed(() => auctionStore.notifications);

  const clearAll = () => {
    apiClient
      .post("/api/notifications/mark-all-as-read")
      .then((response) => {
        if (response.data.success) {
          this.$store.commit("setNotifications", []);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const closePanel = () => {
    emit("closePanel");
  };
</script>
